import { api } from '@/common/api';
import qs from 'qs';
import localReferences from '@/helpers/localReferences';

const store = {
    namespaced: true,
    state() {
        return {
            deals: [],
            measurers: [],
            installers: [],
            managers: [],
            statistic: [],
            dailyPlan: {},
            availableOffices: []
        };
    },

    mutations: {
        setDataFromResponse(state, data) {
            state.deals = data.data.data.deals || [];
            state.measurers = data.data.data.measurers || [];
            state.installers = data.data.data.installers || [];
            state.dailyPlan = data.data.data.dailyPlan || {};
            state.availableOffices = data.data.data.availableOffices || {};
            state.managers = data.data.data.managers || [];
            state.statistic = data.data.data.statistic || [];
        },
        updateDealCoordinates(state, { dealId, coords }) {
            const deal = state.deals.find(deal => deal.id === dealId);
            deal.coordinates = coords;
        },
        changeDealMeasurer(state, { dealId, measurerId, measurerUser }) {
            const changedDeal = state.deals.find(deal => deal.id === +dealId);
            if (changedDeal.measurer_user_id === null) {
                state.statistic[changedDeal.actual_measurement_time].assigned += 1;
                state.statistic[changedDeal.actual_measurement_time].free -= 1;
                state.statistic.all.assigned += 1;
                state.statistic.all.free -= 1;
                if (changedDeal.difficult_metering) {
                    const nextTime = localReferences.getNextTime(changedDeal.actual_measurement_time);
                    if (nextTime) {
                        state.statistic[nextTime].assigned += 1;
                        state.statistic[nextTime].free -= 1;
                        state.statistic.all.assigned += 1;
                        state.statistic.all.free -= 1;
                    }
                }
            } else {
                const oldMeasurer = state.measurers.find(measurer => measurer.id === changedDeal.measurer_user_id);
                oldMeasurer.measurer_deals = oldMeasurer.measurer_deals.filter(deal => deal.id !== changedDeal.id);
            }
            changedDeal.measurer_user_id = +measurerId;
            changedDeal.measurer_user = measurerUser;
            const newMeasurer = state.measurers.find(measurer => measurer.id === +measurerId);
            newMeasurer.measurer_deals.push(changedDeal);
        },
        changeDealInstaller(state, { dealId, installerId, installationUser }) {
            const changedDeal = state.deals.find(deal => deal.id === +dealId);
            if (changedDeal.installation_user_id !== null) {
                const oldInstaller = state.installers.find(installer => installer.id === changedDeal.installation_user_id);
                oldInstaller.installer_deals = oldInstaller.installer_deals.filter(deal => deal.id !== changedDeal.id);
            }
            changedDeal.installation_user_id = +installerId;
            changedDeal.installation_user = installationUser;
            const newInstaller = state.installers.find(installer => installer.id === +installerId);
            newInstaller.installer_deals.push(changedDeal);
        },
        clearStore(state) {
            state.deals = [];
            state.measurers = [];
        }
    },
    actions: {
        async get({ state, commit }, params) {
            try {
                commit('setDataFromResponse', await api.get('/map/measurement/?' + qs.stringify(params)));
            } catch (e) {
                throw new Error(e);
            }
        },
        async getInstallations({ state, commit }, params) {
            try {
                commit('setDataFromResponse', await api.get('/map/installation/?' + qs.stringify(params)));
            } catch (e) {
                throw new Error(e);
            }
        },
        async getCoordinatesByAddress({ state, commit }, address) {
            try {
                const response = await api.get('/dadata/address/find-by-address/' + address);
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async updateCoordinates({ state, commit }, { dealId, coords }) {
            try {
                commit('updateDealCoordinates', { dealId, coords });
                await api.put('/map/coordinates/', { dealId, coords });
            } catch (e) {
                throw new Error(e);
            }
        },
        async changeMeasurer({ state, commit }, { dealId, measurerId }) {
            try {
                const response = await api.put('/map/measurer/', { dealId, measurerId });
                commit('changeDealMeasurer', { dealId, measurerId, measurerUser: response.data.data.measurerUser });
            } catch (e) {
                throw new Error(e);
            }
        },
        async changeInstaller({ state, commit }, { dealId, installerId }) {
            try {
                const response = await api.put('/map/installer/', { dealId, installerId });
                commit('changeDealInstaller', { dealId, installerId, installationUser: response.data.data.installationUser });
            } catch (e) {
                throw new Error(e);
            }
        },
        async informMeasurers({ state, commit }, params) {
            try {
                const response = await api.post('/map/measurement/inform/', params);
                return response.data.data;
            } catch (e) {
                throw new Error(e);
            }
        },
        async informInstallers({ state, commit }, params) {
            try {
                const response = await api.post('/map/installation/inform/', params);
                return response.data.data;
            } catch (e) {
                throw new Error(e);
            }
        },
        async updateInstallLimitPerDay({ state, commit }, params) {
            try {
                const response = await api.post('/map/installation/update-max-install-limit/', params);
                return response.data.data;
            } catch (e) {
                throw new Error(e);
            }
        }
    }
};

export default store;
